import { gql } from "apollo-boost"

export const getContractsBySubmissionId = gql`
  query getContractsBySubmissionId($id: ID!) {
    ContractsBySubmissionID(submissionID: $id) {
      id
      description
      isLeaseContract
      validity
      isBlocked
      concept {
        id
        name
      }
      documents {
        id
        name
        type
        url
      }
    }
  }
`